export default __webpack_public_path__ + "static/logo-c0d24f96d10e26c87df4bf6a42a5451a.png";